import React from "react";
import GoogleLogin from "react-google-login";

const GoogleLoginComponent = ({ onLogin }) => {
  const onLoginFailed = () => {
    // console.log(err);
  };

  return (
    <GoogleLogin
      clientId= {process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID}
      fields="first_name,last_name,email"
      buttonText="Google"
      onSuccess={onLogin}
      onFailure={onLoginFailed}
      cookiePolicy={"single_host_origin"}
      icon={true}
      className="google-btn"
      disabled={false}
      render={(renderProps) => (
        <section>
           <button
          className="gle-btn"
          onClick={renderProps.onClick}
          disabled={renderProps.disabled}
        >
          <img
            src="/images/icon/google-icon.png"
            alt="Google Icon"
            height={20}
            width={20}
            //style={{ width: '20px',  }}
          />
           <span className="ml-2">Google</span>
        </button>
        </section>
       
      )}
    />
  );
};

export default GoogleLoginComponent;
